<template>
  <div class="big-box">
    <div class="main">
      <navigation :crumbs="crumbs" @jumpColumn="jumpColumn" />
      <div class="info-page">
        <div style="clear:both" />
        <div class="title">{{ content.title }}</div>
        <div class="subtitle">
          <span v-if="content.source" class="time">
            来源：
            <font>{{ content.source }}</font>
          </span>

          <span v-if="content.publishedtime" class="time">
            发布时间：
            <font>{{ content.publishedtime | parseTime('{y}-{m}-{d}') }}</font>
          </span>
          <!-- <span v-if="content.readCount" class="time">
            浏览次数：
            <font color="#4C91E3">{{ content.readCount }}</font>
          </span> -->
        </div>
        <video v-if="content.videoPath" controls class="video-style" :src="content.videoPath" />
        <div class="content new-content" v-html="content.content" />
        <div class="other-info">
          <div v-if="content.reporter">记者： {{ content.reporter }}</div>
          <div v-if="content.editor">编辑： {{ content.editor }}</div>
          <div v-if="content.publishedid">编校： {{ content.publishedid }}</div>
          <div v-if="content.auditUsername">审发： {{ content.auditUsername }}</div>
        </div>
        <div v-if="content.attachmentPath && content.attachmentPath != '[]' " class="file-list">
          <div class="title">附件：</div>
          <div v-for="file in content.attachmentPath" :key="file.uid" class="file-item">
            <div class="name">{{ file.name }}</div>
            <span :href="cfg.imageDomain + file.url" :download="file.name" class="down-file" @click="fileDownLoad(file.url,file.name)">下载</span>
            <span :href="cfg.imageDomain + file.url" target="_blank" class="down-file" @click="filePreview(file.url,file.name)">查看内容</span>
          </div>
        </div>
        <div class="foot">
          <div v-if="content.prevArticleTitle">
            上一条：
            <a @click="jump(content.prevArticleId)">{{ content.prevArticleTitle }}</a>
          </div>
          <div v-if="content.nextArticleTitle">
            下一条：
            <a @click="jump(content.nextArticleId)">{{ content.nextArticleTitle }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import { getContent } from '@/api/common';
import navigation from '@/components/navigation';
import { getNavigation } from '@/api/common';
export default {
  name: 'Index',
  components: {
    navigation
  },
  data() {
    return {
      newsTitle: '辟谣要闻',
      noticeTitle: '公告栏',
      newList: { },
      noticeList: { },
      content: '',
      id: '',
      crumbs: []
    };
  },
  computed: {
    ...mapState(['platFromArray', 'columnTree'])
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(route) {
        const { query } = route;
        console.log(query)
        this.getContent(query);
      }
    }
  },
  methods: {
    getContent(data) {
      // data = this.buildParams(data);
      getContent(data).then(res => {
        const content = res.data;
        this.content = content;

        this.columnList(content.customLabel)

        window.scrollTo({ top: 0 })
      });
    },
    jump(id) {
      this.getContent({ id }).then(res => {
        this.content = res.data;
        console.log(this.content);
      });
    },
    columnList(name) {
      getNavigation(name).then(res => {
        console.log('%c 🥧 res.data: ', 'font-size:20px;background-color: #E41A6A;color:#fff;', res.result);
        const columnListArr = JSON.parse(res.data.value)
        this.getCrumbs(name, columnListArr);
      })
    },
    getCrumbs(columnName, columnObj, crtColumn) {
      const topColumnName = columnObj.filter(v => v.text === columnName);
      // 顶级
      if (topColumnName.length) {
        this.crumbs = [columnName];
        return;
      }
    },
    getCurrentColumn(columnName, columnList) {
      let crtColumn = {};
      for (let index = 0; index < columnList.length; index++) {
        const column = columnList[index];
        if (column.columnList && (columnName !== column.name)) {
          crtColumn = this.getCurrentColumn(columnName, column.columnList)
        } else if (columnName === column.name) {
          crtColumn = column;
        }
      }
      return crtColumn;
    },
    jumpColumn(colubName) {
      // 判断当前栏目是否是 单页 如果是单页
      if (!this.content.columnType) {
        this.$router.push({
          path: '/subPage',
          query: {
            name: colubName
          }
        })
      }
    },
    filePreview(filePath, fileName) {
      // 判断文件格式
      var previewType = ['txt', 'png', 'jpg', 'pdf'];
      var fileType = fileName.split('.');
      fileType = fileType[fileType.length - 1];
      if (!previewType.includes(fileType)) {
        this.$message.warning('该类型文件暂不支持预览');
        return
      }
      var a = document.createElement('a');
      a.style.display = 'none';
      // a.download = fileName;
      // var blob = new Blob(this.cfg.imageDomain + filePath); // 字符内容转变成blob地址
      // a.href = URL.createObjectURL(blob);
      a.href = this.cfg.imageDomain + filePath;
      document.body.appendChild(a);
      a.click(); // 触发点击
      document.body.removeChild(a); // 然后移除
    },
    fileDownLoad(filePath, fileName) {
      var x = new XMLHttpRequest()
      var uri = this.cfg.imageDomain + filePath;
      x.open('GET', uri, true);
      x.responseType = 'blob';
      x.onload = function(e) {
        download(x.response, fileName, x.response.type);
      };
      x.send();
    }
  }
};
</script>

<style lang="less" scoped>
.big-box {
  width: 100%;
  font-family: '宋体';
  .main {
  }
}
.video-style{
  width: 720px;
  height: 480px;
  margin-left: 50%;
  transform: translateX(-50%);
}
.main {
  overflow: hidden;
  margin-top: 14px;
  width: 1200px;
  padding: 0;
  margin: 0 auto;
  position: relative;
  margin-top: 14px;
}
@media screen and (max-width: 768px) {
  .video-style {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  .main {
    width: 100%;
    max-width: 100%;
    padding: 0 10px;
  }
}
.page-title {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font: 600 14px/40px PingFangHK;
  background: #99bce0;
  padding-left: 10px;
  font-family: 宋体;
}
.flex_row_center {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.site_img {
  width: 20px;
  height: 24px;
  margin-right: 10px;
}
.title {
  line-height: 38px;
}
.info-page {
  background: #fff;
  padding: 30px;
  overflow: hidden;
  margin-top: 14px;
  line-height: 30px;
  min-height: 200px;
}
.info-page .title {
  clear: both;
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
  font-size: 36px;
  line-height: 47px;
  color: #0060B5;
}
.info-page .subtitle {
  display: flex;
  justify-content:space-around;
  margin-top: 40px;
  padding-bottom: 60px;
  border-bottom: 1px solid #CCCCCC;
}
.info-page .time {
  font-size: 18px;
  color: #9b9b9b;
  margin-right: 20px;
}
.new-content{
  padding: 40px 0;
  font-size: 18px;
  border-bottom: 1px solid #CCCCCC;
  /deep/ img {
    margin: 0 !important;
    margin-left: 50% !important;
    transform: translateX(-50%);
  }
}
.file-list{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .file-item{
    display: flex;
    .down-file{
      margin-left: 20px;
      &:hover{
        color: #367dbe;
      }
    }
  }
}
.other-info{
  margin-top: 40px;
  div{
    font-size: 18px;
    font-weight: 400;
    line-height: 36px;
    color: #666666;
  }
}
.foot {
  margin-top: 20px;
  margin-left: 10px;
  font-size:14px;
  font-family:宋体;
}
.foot div{
  margin-top: 20px;
}
.foot div a:hover{
 color: #337ab7;
 text-decoration: underline;
}
@media screen and (max-width: 768px) {
  .info-page {
    padding: 15px;
  }
  .info-page .title {
    font-size: 24px;
    line-height: 32px;
  }
  .info-page .subtitle {
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    margin-top: 20px;

    .time {
      margin-bottom: 5px;
      font-size: 14px;
    }
  }
}
</style>
